'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  flex-shrink: 0;\n'], ['\n  flex-shrink: 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  overflow: hidden;\n  flex-flow: row nowrap;\n  height: 100%;\n'], ['\n  display: flex;\n  overflow: hidden;\n  flex-flow: row nowrap;\n  height: 100%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  flex-grow: 1;\n  flex-shrink: 1;\n  box-sizing: border-box;\n  padding: 20px 24px;\n  overflow: auto;\n'], ['\n  flex-grow: 1;\n  flex-shrink: 1;\n  box-sizing: border-box;\n  padding: 20px 24px;\n  overflow: auto;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  overflow: hidden;\n  box-shadow: 0px 5px 16px -2px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  flex-shrink: 0;\n'], ['\n  overflow: hidden;\n  box-shadow: 0px 5px 16px -2px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  flex-shrink: 0;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n'], ['\n  display: flex;\n  justify-content: center;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  padding: 24px;\n  display: flex;\n  justify-content: center;\n'], ['\n  padding: 24px;\n  display: flex;\n  justify-content: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _toc = require('./toc');

var _toc2 = _interopRequireDefault(_toc);

var _controls = require('../controls');

var _controls2 = _interopRequireDefault(_controls);

var _slide = require('../slide');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var limitBy = function limitBy(val, min, max) {
  return Math.max(min, Math.min(val, max));
};

var SlideshowMode = function (_React$Component) {
  _inherits(SlideshowMode, _React$Component);

  function SlideshowMode(props) {
    _classCallCheck(this, SlideshowMode);

    var _this = _possibleConstructorReturn(this, (SlideshowMode.__proto__ || Object.getPrototypeOf(SlideshowMode)).call(this, props));

    _this.recalcViewport = function () {
      if (_this._slideCont) {
        var original = _this.props.slideWidth;
        var width = _this._slideCont.clientWidth;
        var value = limitBy(width, original * 0.5, original);

        _this.setState({
          viewportWidth: value
        });
      }
    };

    _this.state = {
      viewportWidth: props.slideWidth
    };
    return _this;
  }

  _createClass(SlideshowMode, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.showToc !== this.props.showToc) {
        this.recalcViewport();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.recalcViewport);
      this.recalcViewport();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.recalcViewport);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          slide = _props.slide,
          showToc = _props.showToc;


      return _react2.default.createElement(
        Slideshow,
        null,
        showToc && _react2.default.createElement(TocColumn, this.props),
        _react2.default.createElement(
          Main,
          null,
          _react2.default.createElement(
            CurrentSlide,
            { innerRef: function innerRef(el) {
                return _this2._slideCont = el;
              } },
            _react2.default.createElement(SlideCard, {
              key: slide.index,
              slide: slide,
              width: this.props.slideWidth,
              height: this.props.slideHeight,
              fitInto: { width: this.state.viewportWidth }
            })
          ),
          _react2.default.createElement(
            Footer,
            null,
            _react2.default.createElement(_controls2.default, this.props)
          )
        )
      );
    }
  }]);

  return SlideshowMode;
}(_react2.default.Component);

var TocColumn = (0, _styledComponents2.default)(_toc2.default)(_templateObject);

var Slideshow = _styledComponents2.default.div(_templateObject2);

var Main = _styledComponents2.default.div(_templateObject3);

var SlideCard = (0, _styledComponents2.default)(_slide.Slide)(_templateObject4);

var CurrentSlide = _styledComponents2.default.div(_templateObject5);

var Footer = _styledComponents2.default.div(_templateObject6);

exports.default = SlideshowMode;